import createIcon from '../../createIcon';

/**
 * @component @name Gif
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgOUgxMS41VjE1SDEzVjlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNOSA5SDZDNS40IDkgNSA5LjUgNSAxMFYxNEM1IDE0LjUgNS40IDE1IDYgMTVIOUM5LjYgMTUgMTAgMTQuNSAxMCAxNFYxMkg4LjVWMTMuNUg2LjVWMTAuNUgxMFYxMEMxMCA5LjUgOS42IDkgOSA5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE5IDEwLjVWOUgxNC41VjE1SDE2VjEzSDE4VjExLjVIMTZWMTAuNUgxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Gif = createIcon('Gif', [
  ['path', { d: 'M13 9H11.5V15H13V9Z', key: '1d8nso' }],
  [
    'path',
    {
      d: 'M9 9H6C5.4 9 5 9.5 5 10V14C5 14.5 5.4 15 6 15H9C9.6 15 10 14.5 10 14V12H8.5V13.5H6.5V10.5H10V10C10 9.5 9.6 9 9 9Z',
      key: 's3wqx7',
    },
  ],
  ['path', { d: 'M19 10.5V9H14.5V15H16V13H18V11.5H16V10.5H19Z', key: '1dl8qs' }],
]);

export default Gif;
